export enum SwitchType {
  /**
   * 3D 配置器
   */
  Three = 0,

  /**
   * 新 2D 配置器
   */
  New = 1,

  /**
   * 历史配置器
   */
  History = 2,
}

export interface Switch3DReq {
  /**
   * 机型
   */
  mobile_type?: string

  /**
   * 车型code，例如：ES8
   */
  model_code?: string

  /**
   * 1 老ES8，2 新ES8，其他为空
   */
  new_version?: number
}

/**
 * 3D配置器开关
 */
export interface Switch3DRes {
  data: {
    /**
     * 3D配置器开关，0 新3D配置器，1 新2D配置器，2 老配置器
     */
    switch_type: SwitchType

    /**
     * 车型停售提示文案
     */
    model_stop_sale_tip: string

    model_list: {
      /**
       * 车型code，例如：ES8
       */
      model_code: string

      /**
       * 3D模型url
       */
      model3d_url: string

      /**
       * 3D模型 md5
       */
      model3d_md5: string

      /**
       * 全景图url
       */
      res_url: string

      /**
       * 多模型
       */
      generation_list?: {
        generation_code_list: string[]
        res_url: string
      }

      /**
       * 图片
       */
      img_url: string

      /**
       * 文案
       */
      desc_list: string[]

      /**
       * 车型售卖状态，1 在售，2 停售
       */
      model_sale_status: 1 | 2
    }[]

    web_pack: {
      framework_url: string
      data_url: string
      loader_url: string
      code_url: string
    }[]
  }
}
